export default function Reducer(state, action) {
  switch (action.type) {
    case 'GET_TOKEN':
      return {
        ...state,
        token: action.token,
      };
    case 'LOAD':
      return {
        ...state,
        chats: action.chats,
      };
    case 'LOAD_CHAT':
      return {
        ...state,
        currentChatId: action.chat.session_id,
        currentChat: action.chat,
        currentChatTrigger: 'click',
        startSessionDate: Date.now(),
      };
    case 'LOAD_AVATAR':
      return {
        ...state,
        avatar: action.avatar,
      };
    case 'SET_CURRENT_CHAT_ID':
      return {
        ...state,
        currentChatId: action.chatId,
      };
    case 'SET_CHAT_TITLE':
      return {
        ...state,
        chats: state.chats.map((chat) => {
          if (chat.session_id === action.chatId && chat.title !== action.title) {
            return {
              ...chat,
              title: action.title,
            };
          }
          return chat;
        }),
      };
    case 'DELETE_CHAT':
      return {
        ...state,
        chats: state.chats.filter((chat) => chat.session_id !== action.chatId),
      };
    case 'NEW_CHAT':
      return {
        ...state,
        currentChat: null,
        startSessionDate: Date.now(),
        currentChatTrigger: 'click',
      };

    case 'NEW_CHAT_AFTER_DELETE':
      return {
        ...state,
        currentChat: null,
        startSessionDate: Date.now(),
        currentChatTrigger: 'delete',
      };

    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
